var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "widget": _vm.widget,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList
    }
  }, [_c('div', {
    staticClass: "drawer-container",
    class: [_vm.selected ? 'selected' : '', _vm.customClass],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectWidget(_vm.widget)
      }
    }
  }, [_c('draggable', _vm._b({
    attrs: {
      "list": _vm.widget.widgetList,
      "handle": ".drag-handler",
      "move": _vm.checkContainerMove
    },
    on: {
      "end": function (evt) { return _vm.onDrawerDragEnd(evt, _vm.widget.widgetList); },
      "add": function (evt) { return _vm.onDrawerDragAdd(evt, _vm.widget.widgetList); },
      "update": _vm.onDrawerDragUpdate
    }
  }, 'draggable', {
    group: 'dragGroup',
    ghostClass: 'ghost',
    animation: 200
  }, false), [_c('transition-group', {
    staticClass: "vf-drawer-drop-zone",
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_vm._l((_vm.widget.widgetList), function(subWidget, swIdx) {
    return [('container' === subWidget.category) ? [_c(subWidget.type + '-widget', {
      key: subWidget.id,
      tag: "component",
      attrs: {
        "widget": subWidget,
        "designer": _vm.designer,
        "parent-list": _vm.widget.widgetList,
        "index-of-parent-list": swIdx,
        "parent-widget": _vm.widget
      }
    })] : [_c(subWidget.type + '-widget', {
      key: subWidget.id,
      tag: "component",
      attrs: {
        "field": subWidget,
        "designer": _vm.designer,
        "parent-list": _vm.widget.widgetList,
        "index-of-parent-list": swIdx,
        "parent-widget": _vm.widget,
        "design-state": true
      }
    })]]
  })], 2)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864c23f0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/container-widget/vf-drawer-widget.vue
// module id = null
// module chunks = 